import React, { useState, useEffect, useContext, useMemo } from "react";
import axios from "axios";

import { NotificationManager } from "react-notifications";
import { makeStyles } from "@mui/styles";
import UserService from "services/UserService";
import Tooltip from "@mui/material/Tooltip";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import { getMBMEquipments, getMBMCampaignEquipments, putPoints } from "services/ConfigServices";
import styled from "styled-components";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { campaignequipmenttext, campaignpointtext } from "variables/MBM/campaign";
import { equipmentinstalledData, equipmentstatusData } from "variables/MBM/lists/campaign";
import { stateData } from "variables/MBM/lists/equipments";
import { dico } from "variables/lists/dico";
import { definitionData } from "variables/MBM/lists/equipments";
import DataTable from "react-data-table-component";
import _ from "lodash";
import ExportTableToCSV from "components/ExportTableToCSV/ExportTableToCSV";
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import StopIcon from '@mui/icons-material/Stop';
import Button from "components/CustomButtons/Button.js";

const Container = styled.div`
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.15);
  border-top: 4px solid rgba(255, 255, 255, 1);
  background-color: white;
  margin-top: -0.5px;
`;
const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;
const UploadButton = styled.div`
  margin-left: 0px;
  &:hover {
    cursor: pointer;
  }
`;

const useStyles = makeStyles(styles);

const emailPattern = new RegExp(
  /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/i
);

function CampaignDialog(props) {
  const memv2versionactive = localStorage.getItem('memv2version') || 0;
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const mbmadmin = permis.includes("mbm_admin");
  const { closeModal, refetch, setLoading, currentCampaign } = props;

  const advancedSearchContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, groupInfoListById } = advancedSearchContext;

  const [mbmequipments, setMbmequipments] = useState([]); //all equiments for selected group

  const [equipments, setEquipments] = useState([]);
  const [points, setPoints] = useState([]);
  const [selectedequipments, setSelectedequipments] = useState([]);
  const [currentequipment, setCurrentequipment] = useState("");
  const [open, setOpen] = useState(false);
  const [currentpoint, setCurrentpoint] = useState("");
  const [openpoint, setOpenpoint] = useState(false);

  const classes = useStyles();

  useEffect(() => {
    if (currentCampaign.parameters.general.groups) {
      axios
        .get(getMBMEquipments(currentCampaign.parameters.general.groups, "false"), {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        })
        .then((res) => {
          setMbmequipments(res.data.equipments);
        });
    }
  }, [currentCampaign.parameters.general.groups]);

  const [refresh, setRefresh] = useState(false);
  useEffect(() => {
    if (currentCampaign?.id) {
      axios
        .get(getMBMCampaignEquipments(currentCampaign.id), {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        })
        .then((res) => {
          let eqs = res.data.equipments.map((item) => {
            let eq = { ...item };
            let eqpoints = res.data.points.filter((x) => x.campaignequipmentid === item.id);
            let status = 0;
            eqpoints.forEach((point) => {
              console.log(point.state, status);
              if (point.state == 0) //viewer
              {
                if (status == 0)
                  status = 2; //tout actif
                else if (status == 1)
                  status = 3; //actif & inactif
              }
              else if (point.state == 3) //inactif
              {
                if (status == 0)
                  status = 1; //tout inactif
                else if (status == 2)
                  status = 3; //actif & inactif
              }
            })
            eq.status = status;
            return eq;
          });
          console.log(eqs);
          setEquipments(eqs);
          setPoints(res.data.points);
        });
    }
  }, [currentCampaign.parameters.general.groups, refresh]);
  const refreshTable = () => {
    setRefresh(!refresh);
  }

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };


  const equipmentscolumns = [
    // {
    //   name: campaignequipmenttext.id,
    //   selector: (row) => row.id,
    //   sortable: true,
    //   maxWidth: "8rem",
    //   cell: (row) => row.id
    // },
    {
      name: campaignequipmenttext.campaignname,
      selector: (row) => row.parameters.campaignname,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.parameters.campaignname
    },
    {
      name: campaignequipmenttext.campaigngroup,
      selector: (row) => row.parameters.campaigngroup,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) => groupInfoListById["" + row.parameters.campaigngroup] || ""
    },
    {
      name: campaignequipmenttext.localization,
      selector: (row) => row.parameters.localization,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) => row.parameters.localization
    },
    {
      name: campaignequipmenttext.definition,
      selector: (row) => row.parameters.definition,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => definitionData.find((x) => x.id == row.parameters.definition)?.name || ""
    },
    {
      name: campaignequipmenttext.status,
      selector: (row) => row.status,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => equipmentstatusData.find((x) => x.id == row.status)?.name || ""
    },
    {
      name: "",
      sortable: false,
      width: "10rem",
      cell: (row) => (
        <>
          <div className="actions-right">          
            <Tooltip title="Activer toutes les mesures">
              <Button
                onClick={editEquipmentPointStatus(row,0)}
                color={"success"}
                className={classes.actionButton}
                disabled={row.status == 0 || row.status == 2}
              >
                <PlayArrowIcon fontSize="large" />
              </Button>
            </Tooltip>
            <Tooltip title="Stoper toutes les mesures">
              <Button
                onClick={editEquipmentPointStatus(row,3)}
                color={"warning"}
                className={classes.actionButton}
                disabled={row.status == 0 || row.status == 1}
              >
                <StopIcon fontSize="large" />
              </Button>
            </Tooltip>
          </div>
        </>
      ),
    },
  ]

  const pointscolumns = [
    {
      name: campaignpointtext.name,
      selector: (row) => row.name,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.name,
    },
    {
      name: campaignpointtext.group,
      selector: (row) => row.groupid,
      sortable: true,
      // maxWidth: "12rem",
      cell: (row) => groupInfoListById["" + row.groupid] || ""
    },
    {
      name: campaignpointtext.definition,
      selector: (row) => row.definition,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => dico.find((x) => x.id == row.definition)?.name || ""
    },
    {
      name: campaignpointtext.unit,
      selector: (row) => row.definition,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => dico.find((x) => x.id == row.definition)?.unit || ""
    },
    {
      name: campaignpointtext.conversion,
      selector: (row) => row.conversion,
      sortable: true,
      maxWidth: "8rem",
      cell: (row) => row.conversion,
    },
    {
      name: campaignpointtext.state,
      selector: (row) => row.state,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => stateData.find((x) => x.id == row.state)?.name || ""
    },
    {
      name: "",
      sortable: false,
      width: "10rem",
      cell: (row) => (
        <>
          <div className="actions-right">
            <Tooltip title="Activer la mesure">
              <Button
                onClick={editPointStatus(row, 0)}
                color={"success"}
                className={classes.actionButton}
                disabled={row.state == 0}
              >
                <PlayArrowIcon fontSize="large" />
              </Button>
            </Tooltip>
            <Tooltip title="Stoper la mesure">
              <Button
                onClick={editPointStatus(row, 3)}
                color={"warning"}
                className={classes.actionButton}
                disabled={row.state == 3}
              >
                <StopIcon fontSize="large" />
              </Button>
            </Tooltip>
          </div>
        </>
      ),
    },
  ];

  const editCampaignEquipment = (row) => async () => {
    let obj = equipments.find((o) => o.id === row.id);
    if (obj) {
      setCurrentequipment(obj);

    }
  }

  const editEquipmentPointStatus = (row, status) => async () => {
    let obj = equipments.find((o) => o.id === row.id);
    if (obj) {
      let eqpoints = points.filter((x) => x.campaignequipmentid === obj.id);
      let pointarray = eqpoints.map((item) => {
        let objtmp = { ...item };
        objtmp.state = status;
        return objtmp;
      });
      updatePointState(pointarray);
    }
  }
  const editPointStatus = (row, status) => async () => {
    let obj = points.find((o) => o.id === row.id);
    if (obj) {
      let objtmp = { ...obj };
      objtmp.state = status;
      let pointarray = [];
      pointarray.push(objtmp);
      updatePointState(pointarray);
    }
  }

  const updatePointState = async (pointarray) => {
    axios
      .put(
        putPoints("state"),
        {
          points: pointarray
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            "Content-Type": "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          setNotification("success", "Statut mis jour");
          refreshTable();
          refetch();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
        // setLoading(false);
      });

  };

  const ExpandableComponent = props => {
    const { data } = props;
    const datadisplay = points.filter((x) => x.campaignequipmentid === data.id);

    return (
      <Container>
        <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
          noDataComponent={<NoData>Aucun Point à afficher</NoData>}
          noHeader={true}
          columns={pointscolumns}
          persistTableHead
          data={datadisplay}
          striped={true}
        //theme="solarized"
        />
      </Container>
    );
  };

  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const SearchComponent = ({ filterText, onFilter, onClear }) => (
    <>
      <div style={{ marginTop: "-7px", marginRight: "10px" }}>
        <TextField
          type="search"
          variant="outlined"
          margin="normal"
          size="small"
          autoFocus="true"
          value={filterText}
          onChange={onFilter}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>
    </>
  );

  const filteredItems = equipments.filter(
    (item) =>
      (item.parameters?.name && item.parameters.name.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters?.groups && groupInfoListById["" + item.parameters.groups] && groupInfoListById["" + item.parameters.groups].toLowerCase().includes(filterText.toLowerCase()))
  );
  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };
    const onFilterText = (e) => setFilterText(e.target.value);
    let exportarray = selectedequipments.map((item) => {
      let equipmenttoexport = {};
      equipmenttoexport[campaignequipmenttext.id] = item.id;
      equipmenttoexport[campaignequipmenttext.name] = item.parameters.name;
      equipmenttoexport[campaignequipmenttext.campaignname] = item.parameters.campaignname;
      equipmenttoexport[campaignequipmenttext.campaigngroup] = groupInfoListById["" + item.parameters.campaigngroup];
      equipmenttoexport[campaignequipmenttext.localization] = item.parameters.localization;
      equipmenttoexport[campaignequipmenttext.definition] = definitionData.find((x) => x.id == item.parameters.definition)?.name;
      equipmenttoexport[campaignequipmenttext.installed] = equipmentinstalledData.find((x) => x.id == item.parameters.installed)?.name;
      return equipmenttoexport;
    });
    return (
      <>
        <SearchComponent
          key="SearchComponent"
          onFilter={onFilterText}
          onClear={handleClear}
          filterText={filterText}
        />
        {mbmadmin && (
          <>
            <UploadButton type="button" onClick={handleClear}>
              {/* <EditMeters refetch={refreshTable} onClick={handleClear} marketmeters={marketmeters} disabled={!marketmeters || marketmeters.length < 1} /> */}
            </UploadButton>
            <UploadButton type="button" onClick={handleClear}>
              {/* <DeleteMeters refetch={refreshTable} onClick={handleClear} marketmeters={marketmeters} disabled={!marketmeters || marketmeters.length < 1} /> */}
            </UploadButton>
          </>
        )}
        <UploadButton type="button" onClick={handleClear}>
          <ExportTableToCSV dataarray={exportarray} disabled={!selectedequipments || selectedequipments.length < 1} />
        </UploadButton>
      </>
    );
  }, [filterText, resetPaginationToggle, equipments, mbmequipments, selectedequipments]);

  const handleSelectedRowsChange = (selection) => {
    setSelectedequipments(selection.selectedRows);
  };

  return (
    <>
      <Container>
        <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
          noDataComponent={<NoData>{"Aucun équipement"}</NoData>}
          noHeader={true}
          columns={equipmentscolumns}
          persistTableHead
          pagination
          subHeader
          data={filteredItems}
          onSelectedRowsChange={handleSelectedRowsChange}
          selectableRows={true}
          expandOnRowClicked={true}
          expandableRows={true}
          expandableRowDisabled={(row) => row.disabled}
          expandableRowsComponent={ExpandableComponent}
          paginationComponentOptions={{
            noRowsPerPage: false,
            rowsPerPageText: "Lignes par page",
            rangeSeparatorText: "sur",
            selectAllRowsItem: false,
            selectAllRowsItemText: "Selectionner toutes les lignes",
          }}
          defaultPageSize={10}
          filterable={true}
          manual={true}
          paginationResetDefaultPage={resetPaginationToggle}
          subHeaderComponent={subHeaderComponentMemo}
        />
      </Container>
    </>
  );
}

export default CampaignDialog;
